// AI Generated Component
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BrokenLinksUtil } from '@client/app/pages/qa/broken-links/broken-links.util';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { QABrokenLinkService } from '@client/app/blocks/service/qa/broken-link.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'broken-images-index',
    standalone: false,
    template: `
        <page-header
                [icon]="(['QA', 'BROKEN_IMAGES'] | monIcons)"
            [header]="('Broken Images' | translate)"
                [subHeader]="'<strong>' + (links.total | monNumber) + '</strong> ' + ('link' | translateWithPlural:links.total:'links')">
        </page-header>
        <mon-tabs
                [showSearch]="true"
                [options]="tabs"
                [(status)]="activeTab"
                (onStatus)="onStatus($event)"
                (onSearch)="onSearch($event)"
                [search]="search"
                [minSearchLength]="1"
                [showFiltersBtn]="true"
                [(isFiltersOpen)]="isFiltersOpen"
        >
            <csv-export-button [exports]="exports"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-48 col-lg-48 col-48">
                        <table-container-top>
                            <div *ngIf="isFiltersOpen">
                                <table-filters
                                        [(open)]="isFiltersOpen"
                                        [(ngModel)]="filters"
                                        [filters]="availableFilters"
                                        (onChanges)="updateFilters($event);getPage()"
                                >
                                </table-filters>
                            </div>
                        </table-container-top>
                        <broken-table
                                [(selected)]="selected"
                                (getPage)="getPage()"
                                [items]="links"
                                (onPageChange)="onPageChange($event)"
                                (onPerPageChange)="onPageSizeChange($event)"
                                [type]="activeTab"
                                [progress]="promise"
                                (onSortPage)="onSortPage($event.direction, $event.by)"
                                [currentSort]="currentSort"
                                [labels]="labels"
                                [selectedLabels]="selectedLabels"
                                (getLabels)="getLabels()">
                        </broken-table>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class BrokenImagesIndexComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    type: string = '';
    selected: any[] = [];
    links: any = [];
    tabs: any[] = [];
    override isFiltersOpen: boolean = false;
    override filters: any = { labels: [], type: [], 'response code': [], 'internal or external': [] };
    override availableFilters: any = {
        labels: [],
        type: [{ id: 'html', name: 'Pages' }, { id: 'document', name: 'Documents' }],
        'response code': [],
        'internal or external': [{ id: 'internal', name: 'Internal' }, { id: 'external', name: 'External' }],
    };
    override activeTab: string = 'dead';
    override search: string = '';
    override currentSort: any = { by: 'dead_on_pages_count', direction: 'desc' };
    exports: any[] = [];
    promise: any;
    override labels: any[] = [];
    override selectedLabels: any[] = [];
    qaBrokenImagesUpdateListener: any;

    constructor (
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private qaBrokenLinkService: QABrokenLinkService,
    ) {
        super({ table: true });
    }

    ngOnDestroy (): void {
        this.onDestroy();
    }

    ngOnInit (): void {
        this.selected = [];
        this.search = '';
        this.type = this.type || 'image';

        this.links = [];
        this.tabs = [
            {
                name: this.translateService.getString('All broken images'),
                faIcon: this.pipeService.get('monIcons')(['LINKS', 'IMAGE']),
                value: 'dead',
            },
            { name: this.translateService.getString('Ignored'), faIcon: 'fas fa-eye-slash', value: 'ignored' },
            { name: this.translateService.getString('Marked as fixed'), faIcon: 'fas fa-check-circle', value: 'fixed' },
        ];

        this.isFiltersOpen = false;
        this.filters = { labels: [], type: [], 'response code': [], 'internal or external': [] };
        this.availableFilters = {
            labels: [],
            type: [{ id: 'html', name: 'Pages' }, { id: 'document', name: 'Documents' }],
            'response code': this.qaBrokenLinkService.getResponseCodes(),
            'internal or external': [{ id: 'internal', name: 'Internal' }, { id: 'external', name: 'External' }],
        };

        this.activeTab = 'dead';
        this.currentSort = { by: 'dead_on_pages_count', direction: 'desc' };
        this.exports = [
            {
                name: this.translateService.getString('Broken images with page count'),
                data: {
                    category: 'dead_images',
                },
            },
            {
                tooltip: this.translateService.getString(
                    'Export list of broken images organized by page and document title',
                ),
                name: this.translateService.getString('Broken Image Links per page'),
                data: {
                    category: 'dead_page_images',
                },
            },
        ];

        this.qaBrokenImagesUpdateListener = this.monEventsService.addListener('reloadQaBrokenImages', () => {
            this.getPage();
        });

        this.getLabels();
        this.getPage();
    }

    override getPage = (): void => {
        this.selected = [];
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search ?? '',
            status: this.activeTab,
            type: this.type,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            page_fixed: false,
        };

        if (this.filters.type.length) {
            params.page_type = this.filters.type[0].id;
        }
        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }
        if (this.filters['internal or external'].length) {
            params.relation = this.filters['internal or external'][0].id;
        }
        if (this.filters['response code'].length) {
            params.status_code = this.filters['response code'][0].id;
        }

        this.promise = this.linksRepoService.getAll(params).then((data: any) => {
            this.links = data;
        }).catch(() => {});
    };

    override updateFilters (changes: any): void {
        if (!changes) {
            return;
        }
        this.selectedLabels = changes[this.translateService.getString('labels')].map((label: any) => {
            return label.id;
        });
        this.filters = BrokenLinksUtil.updateLinksFilters(this.filters, changes);
        this.getPage();
    }

    onDestroy (): void {
        this.monEventsService.remove(this.qaBrokenImagesUpdateListener);
    }
}
